import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';

declare var aptrinsic: any;

@Injectable({
    providedIn: 'root'
})
export class GainsightService {
    private isLoaded = false;

    initGainSight(gainSightConfig: GainSightConfig) {
        if (environment.gainsight.trackingEnabled) {
            aptrinsic('account', gainSightConfig.account);
            aptrinsic('identify',
                gainSightConfig.user,
                gainSightConfig.account);
        }
    }
}

export interface GainSightConfig {
    user: GainSightUser;
    account: GainSightAccount;

    [x: string]: any;
}

export interface GainSightUser {
    id: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    role?: string;

    [x: string]: any;
}

export interface GainSightAccount {
    id: string;
    name?: string;
    sfdcId?: string;
    regionName?: string;

    [x: string]: any;
}
